import React from 'react';

import {LoadingSpinner} from '@newsela/angelou';
import Loadable from 'react-loadable';
import {Route} from 'react-router-dom';


const LazyDistrictReport = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "District-Report" */
      './DistrictReport'
    ),
  loading: LoadingSpinner,
});



const DashRoutes = [
  <Route
    key="District-Report"
    exact path={['/dash/district-report']}
    component={LazyDistrictReport}
  />,
];

export default DashRoutes;
